import React, { useEffect, useState } from 'react';
import './../../App.css';
import './ProfilePage.css';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../components/Header';
import useScrolled from '../../hooks/useScrolled';
import { ProfileSkeleton } from '../../components/layout/Skeletons';
import placeholderImage from './../../assets/placeholder.png';
import ApiService from '../../services/ApiService';
import ProfilePic from '../../components/profilepic/ProfilePic';
import timeIcon from '../../assets/time.svg';
import starIcon from '../../assets/ic_star.svg';
import giftIcon from '../../assets/ic_gift.svg';
import achieveIcon from '../../assets/ic_achieve.svg';
import addFriendIcon from '../../assets/addFriend.svg';
import removeFriendIcon from '../../assets/removeFriend.svg';
import telegramIcon from '../../assets/telegramIcon.svg';
import settingsIcon from '../../assets/ic_settings.svg';
import commentsIcon from '../../assets/ic_comments.svg';
import premium from '../../assets/premium_badge.svg';
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import WatchCardComponent from '../../components/watchcard/WatchCardComponent';
import Footer from '../../components/Footer';
import FriendsPopup from './FriendsPopup';
import ReviewComponent from '../../components/ReviewComponent';
import AnimixPremiumGiftPopup from '../../components/premium/AnimixPremiumGiftPopup';
import FramePopup from './FramePopup';
import { normalizeCdnUrl } from '../../services/CdnUtils';
import ProfileCollectionsCard, { useMangaProfile } from './ProfileCollectionsCard';
import ProfileCollectionsPanel from './ProfileCollectionsPanel';

ChartJS.register(ArcElement, Tooltip, Legend);

const getPluralForm = (value, [one, few, many]) => {
    const absolute = Math.abs(Number(value)) % 100;
    const lastDigit = absolute % 10;
    if (absolute > 10 && absolute < 20) return many;
    if (lastDigit === 1) return one;
    if (lastDigit >= 2 && lastDigit <= 4) return few;
    return many;
};

const ProfilePageContent = () => {
    const { nickname } = useParams();
    const scrolled = useScrolled();
    const [account, setAccount] = useState(null);
    const [email, setEmail] = useState("dummy");
    const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);
    const [notFound, setNotFound] = useState(false);
    const [backgroundLoaded, setBackgroundLoaded] = useState(false);
    const [frames, setFrames] = useState([]);
    const [allFrames, setAllFrames] = useState([]);
    const [selectedFrame, setSelectedFrame] = useState(null);
    const [availableFrameIds, setAvailableFrameIds] = useState(null);
    const [watchHistory, setWatchHistory] = useState([]);
    const [reviewHistory, setReviewHistory] = useState([]);
    const [currentWatchSnippet, setCurrentWatchSnippet] = useState(null);
    const [data, setData] = useState(null);
    const [watchDataPage, setWatchDataPage] = useState(0); // Current page
    const [reviewPage, setReviewPage] = useState(0); // Current page
    const [hasMore, setHasMore] = useState(true); // To track if there's more data
    const [hasMoreReviews, setHasMoreReviews] = useState(true); // To track if there's more data

    const navigate = useNavigate();
    const [showFriendsPopup, setShowFriendsPopup] = useState(false);
    const [showGiftPopup, setShowGiftPopup] = useState(false);



    const [comments, setComments] = useState([]);
    const [commentPage, setCommentPage] = useState(0);
    const [hasMoreComments, setHasMoreComments] = useState(true);
    const [newComment, setNewComment] = useState('');
    const [activityTab, setActivityTab] = useState('history');
    const [collectionsKind, setCollectionsKind] = useState('anime');

    const [showFramePopup, setShowFramePopup] = useState(false);
    const viewerHasSession = !!localStorage.getItem('sessionKey');


    const isOwnProfile = () => {
        const profileId = localStorage.getItem('profileId');
        return profileId !== null && String(profileId) === String(account?.id);
    };

    const canViewPrivateContent = () => {
        return !account?.private || isOwnProfile();
    };
    const canShowWatchHistory = () => {
        return canViewPrivateContent() && viewerHasSession;
    };

    const handleImageError = () => {
        setBackgroundImageUrl(null);
    }

    const handleBackgroundLoad = () => {
        setBackgroundLoaded(true);
    }

    // for some reason ui redraws for the second time
    var isProfileFetched = false;

    const fetchComments = async (id, clear = false) => {
        try {

            const commentsData = await ApiService.getComments("comments_" + id, clear ? 0 : commentPage);
            // console.log(JSON.stringify(commentsData.data))
            if (clear) {
                setCommentPage(1);
            }
            else {

                setCommentPage(prevPage => prevPage + 1);

            }
            if (commentsData.data.length > 0) {
                if (clear) {
                    setComments(commentsData.data);
                }
                else {
                    setComments(prevComments => [...prevComments, ...commentsData.data]);
                }


            } else {
                setHasMoreComments(false);
            }
        } catch (error) {
            console.error('Error fetching comments:', error);
        }
    };


    const loadMoreComments = () => {

        fetchComments(account.id);
    };

    const handleNewCommentChange = (event) => {
        setNewComment(event.target.value);
    };

    const handleLeaveComment = async () => {
        if (newComment.trim() === '') return;
        try {
            const response = await ApiService.leaveComment(newComment, "comments_" + account.id);
            if (response.type === 'success') {
                setComments([response.data, ...comments]);

                setNewComment('');
            } else {
                console.error('Failed to leave comment:', response.message);
            }
        } catch (error) {
            console.error('Error leaving comment:', error);
        }
    };



    useEffect(() => {

        const fetchData = async () => {
            try {
                if (!isProfileFetched) {
                    window.scrollTo(0, 0);
                    isProfileFetched = true;

                    console.log('useEffect triggered');
                    let data;
                    if (nickname) {
                        data = await ApiService.get(nickname);
                    } else {
                        data = await ApiService.getSelf();
                        let email = await ApiService.getEmail();

                        setEmail(email.data);
                    }

                    if (data.type === "success") {
                        console.log('Data fetched successfully');
                        if (!nickname) {
                            navigate(`/profile/${data.data.nickname}`);
                        }

                        setAccount(data.data);
                        fetchComments(data.data.id, true);
                        if (data.data.banned) return;
                        const API_DOMAIN = 'https://api.whitewhale.help';

                        setBackgroundImageUrl(`${API_DOMAIN}/account/getProfileData/${data.data.id}_profile_background.png`);
                        document.title = "Профиль " + data.data.nickname;

                        // Fetch initial watch history
                        const watchData = await ApiService.getWatchHistoryProfile(data.data.id, watchDataPage);
                        setWatchHistory(watchData.data);
                        if (watchData.data && watchData.data.length > 0) {
                            setCurrentWatchSnippet(watchData.data[0]);
                        }

                        const reviewsData = await ApiService.getUserReviews(data.data.id, 0);
                        setReviewHistory(reviewsData.data);




                        // Fetch frames data
                        const framesData = await ApiService.getFrames();
                        const availableFrameIds = [...data.data.availablePicFrames, 0];
                        setAvailableFrameIds(availableFrameIds);
                        const availableFrames = framesData.filter(frame => availableFrameIds.includes(frame.id));
                        setFrames(availableFrames);
                        setAllFrames(framesData);

                        framesData.forEach(frame => {
                            if (String(frame.id) === String(data.data.selectedPicFrame)) {
                                setSelectedFrame(frame);
                            }
                        });

                        // Fetch collections data
                        const collectionsData = await ApiService.getCollections(data.data.id);
                        const collectionsStat = {};
                        collectionsData.data.forEach(element => {
                            if (element.system) {
                                if (element.name === "Просмотрено") {
                                    collectionsStat.watched = element.animeIds.length;
                                }
                                if (element.name === "Брошено") {
                                    collectionsStat.brosheno = element.animeIds.length;
                                }
                                if (element.name === "Отложено") {
                                    collectionsStat.delayed = element.animeIds.length;
                                }
                                if (element.name === "В процессе") {
                                    collectionsStat.progress = element.animeIds.length;
                                }
                                if (element.name === "В планах") {
                                    collectionsStat.plans = element.animeIds.length;
                                }
                            }
                        });
                        setData({
                            labels: ['Просмотрено', 'Брошено', 'Отложено', 'В процессе', 'В планах'],
                            datasets: [{
                                data: [
                                    collectionsStat.watched,
                                    collectionsStat.brosheno,
                                    collectionsStat.delayed,
                                    collectionsStat.progress,
                                    collectionsStat.plans,
                                ],
                                backgroundColor: [
                                    '#79E936', // Просмотрено
                                    '#EB5744', // Брошено
                                    '#FDCF2A', // Отложено
                                    '#929292', // В процессе
                                    '#36B69C'  // В планах
                                ],
                            }]
                        });

                    } else {
                        setNotFound(true);
                    }
                }
            } catch (error) {
                setNotFound(true);
                console.error('Error fetching profile data:', error);
            }
        };

        fetchData();
    }, [nickname]); // Add nickname to the dependency array

    const fetchReviews = async (page) => {
        if (reviewPage === page) return;
        setReviewPage(page);
        try {
            const reviewsData = await ApiService.getUserReviews(account.id, page);
 
            if (reviewsData.data.length > 0) {
                setReviewHistory(prevHistory => [...prevHistory, ...reviewsData.data]);
            } 
            else
            {
                setHasMoreReviews(false);
            }
        } catch (error) {
            console.error('Error fetching watch history:', error);
        }
    };

    const fetchWatchHistory = async (page) => {
        if (watchDataPage === page) return;
        setWatchDataPage(page);
        try {
            const watchData = await ApiService.getWatchHistoryProfile(account.id, page);
            if (watchData.data.length > 0) {
                setWatchHistory(prevHistory => [...prevHistory, ...watchData.data]);
            } else {
                setHasMore(false); // No more data to load
            }
        } catch (error) {
            console.error('Error fetching watch history:', error);
        }
    };


    function formatDate(milliseconds) {
        const months = [
            'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
            'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
        ];

        const date = new Date(milliseconds);
        if (!milliseconds || Number.isNaN(date.getTime())) return 'давно';
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();

        return `${day} ${months[monthIndex]} ${year}`;
    }


    const handleAddFriend = async () => {
        try {
            const response = await ApiService.addFriend(account.id); // Call ApiService to add friend
            if (response.type === 'success') {
                setAccount(prevAccount => ({
                    ...prevAccount,
                    myFriend: true
                }));
            } else {
                console.error('Failed to add friend:', response.message);
            }
        } catch (error) {
            console.error('Error adding friend:', error);
        }
    };
    const toggleFriendsPopup = () => {
        setShowFriendsPopup(!showFriendsPopup);
    };


    const handleRemoveFriend = async () => {
        try {
            const response = await ApiService.removeFriend(account.id); // Call ApiService to add friend
            if (response.type === 'success') {

                setAccount(prevAccount => ({
                    ...prevAccount,
                    myFriend: false
                }));
            } else {
                console.error('Failed to add friend:', response.message);
            }
        } catch (error) {
            console.error('Error adding friend:', error);
        }
    };

    const friends = Array.isArray(account?.friendsEntities) ? account.friendsEntities : [];
    const friendsCount = Array.isArray(account?.friendsList) ? account.friendsList.length : friends.length;
    const watchCount = Number(account?.watchCount) || 0;
    const manga = useMangaProfile(account?.id);
    const watchHours = Math.round(watchCount * 20 / 60 * 10) / 10;
    const weeklyWatchHours = Math.round((Number(account?.watchCountLastWeek) || 0) * 20 / 60 * 10) / 10;
    const lastSeenDate = account?.lastWatchedTime ? new Date(account.lastWatchedTime) : null;
    const isOnline = lastSeenDate && !Number.isNaN(lastSeenDate.getTime())
        ? ((new Date() - lastSeenDate) / (1000 * 60) <= 5)
        : false;

    return (
        <div className={`profile-page${account?.subscribed ? ' is-premium' : ''}`}>
            <Header scrolled={scrolled} />
            {account?.subscribed && backgroundImageUrl ? (
                <img
                    src={backgroundImageUrl}
                    onError={handleImageError}
                    alt=""
                    onLoad={handleBackgroundLoad}
                    className={`profile-page__background ${backgroundLoaded ? 'visible' : ''}`}
                />
            ) : null}
            {account !== null ? (
                <div className="profile-page__content ui-enter">
                    <section className="profile-hero">
                        {!account.subscribed ? (
                            <img
                                src={backgroundImageUrl ?? placeholderImage}
                                onError={handleImageError}
                                alt=""
                                onLoad={handleBackgroundLoad}
                                className={`profile-header-photo ${backgroundLoaded ? 'visible' : ''}`}
                            />
                        ) : null}
                        <div className="profile-hero__shade" />
                        <div className="profile-hero__inner">
                            <div className="profile-hero__avatar">
                                <ProfilePic isBig={true} account={account ?? {}} />
                            </div>

                            <div className="profile-hero__body">
                                <div className="profile-roles">
                                    {account.mod ? <span className="mod-text">Модерация</span> : null}
                                    {account.editor ? <span className="editor-text">Редактор</span> : null}
                                    {account.subscribed ? <span className="profile-premium-label">animix premium</span> : null}
                                </div>

                                <div className="profile-hero__name-row">
                                    <h1>{account.nickname}</h1>
                                    {account.subscribed ? <img src={premium} alt="Premium" /> : null}
                                </div>

                                <div className="profile-hero__meta">
                                    <span className={isOnline ? 'is-online' : ''}><i />{isOnline ? 'Сейчас онлайн' : 'Не в сети'}</span>
                                    <span>На animix с {formatDate(account.registrationDate)}</span>
                                    {account.id !== undefined && account.id !== null ? <span>ID {account.id}</span> : null}
                                </div>

                                <p className={`profile-desc${account.description ? '' : ' is-empty'}`}>
                                    {account.description || 'Пользователь пока ничего о себе не рассказал.'}
                                </p>

                                <div className="profile-hero__actions">
                                    {isOwnProfile() ? (
                                        <button className="profile-action is-primary is-settings" onClick={() => navigate('/settings')}>
                                            <img src={settingsIcon} alt="" />
                                            Настроить профиль
                                        </button>
                                    ) : (
                                        <button className="profile-action is-primary is-friend" onClick={() => {
                                            if (!viewerHasSession) {
                                                navigate('/login');
                                                return;
                                            }
                                            account.myFriend ? handleRemoveFriend() : handleAddFriend();
                                        }}>
                                            <img src={account.myFriend ? removeFriendIcon : addFriendIcon} alt="" />
                                            {!viewerHasSession
                                                ? 'Войти, чтобы добавить'
                                                : account.myFriend ? 'Убрать из друзей' : 'Добавить в друзья'}
                                        </button>
                                    )}

                                    {account.telegram && canViewPrivateContent() ? (
                                        <a className="profile-action is-icon" href={account.telegram} target="_blank" rel="noreferrer" aria-label="Открыть Telegram">
                                            <img src={telegramIcon} alt="" />
                                        </a>
                                    ) : null}

                                    {!isOwnProfile() && !account.subscribed ? (
                                        <button className="profile-action is-icon is-gift" onClick={() => setShowGiftPopup(true)} aria-label="Подарить Premium">
                                            <img src={giftIcon} alt="" />
                                        </button>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </section>
                    <main className="profile-dashboard">
                        {/* Left column: watch figures, collections, frames (and manga when there is any). */}
                        <aside className="profile-dashboard__side">
                            {canViewPrivateContent() ? (
                                <section className="profile-card profile-figures-card">
                                    <div className="profile-card__header">
                                        <span className="profile-card__icon"><img src={timeIcon} alt="" /></span>
                                        <div><h2>Просмотр</h2></div>
                                    </div>
                                    <div className="profile-figures">
                                        <div className="is-accent"><strong>{watchHours}</strong><span>часов всего</span></div>
                                        <div><strong>{watchCount}</strong><span>{getPluralForm(watchCount, ['серия', 'серии', 'серий'])}</span></div>
                                        <div><strong>{weeklyWatchHours}</strong><span>часов за неделю</span></div>
                                        <button type="button" className="is-link" onClick={toggleFriendsPopup} disabled={friends.length === 0}>
                                            <strong>{friendsCount}</strong>
                                            <span>{getPluralForm(friendsCount, ['друг', 'друга', 'друзей'])}</span>
                                        </button>
                                    </div>
                                </section>
                            ) : null}

                            {canViewPrivateContent() ? (
                                <ProfileCollectionsCard
                                    animeData={data}
                                    manga={manga}
                                    onOpen={(kind) => { setCollectionsKind(kind); setActivityTab('collections'); }}
                                />
                            ) : null}

                            <section className="profile-card profile-frames-card">
                                <div className="profile-card__header">
                                    <span className="profile-card__icon"><img src={achieveIcon} alt="" /></span>
                                    <div>
                                        <h2>Рамки</h2>
                                        <p>{availableFrameIds?.length || 0} в коллекции</p>
                                    </div>
                                </div>
                                {availableFrameIds?.length ? (
                                    <div className="profile-frames-grid">
                                        {availableFrameIds.map((id) => {
                                            const frame = frames.find((item) => item.id === id);
                                            if (!frame?.url) return null;
                                            return (
                                                <button key={id} type="button" onClick={() => setShowFramePopup(true)} aria-label={frame.desc || 'Открыть рамку'}>
                                                    <img src={normalizeCdnUrl(frame.url)} alt="" />
                                                </button>
                                            );
                                        })}
                                    </div>
                                ) : <div className="profile-empty-state is-small"><p>Рамок пока нет.</p></div>}
                                <button type="button" className="profile-card__more" onClick={() => setShowFramePopup(true)}>Все рамки</button>
                            </section>

                        </aside>

                            <section className="profile-card profile-activity">
                                <div className="profile-activity__tabs" role="tablist" aria-label="Активность">
                                    {[
                                        { key: 'history', label: 'История' },
                                        { key: 'reviews', label: 'Отзывы' },
                                        { key: 'comments', label: 'Комментарии' },
                                        ...(canViewPrivateContent() ? [{ key: 'collections', label: 'Коллекции' }] : []),
                                    ].map((tab) => (
                                        <button
                                            key={tab.key}
                                            type="button"
                                            role="tab"
                                            aria-selected={activityTab === tab.key}
                                            className="profile-activity__tab"
                                            onClick={() => setActivityTab(tab.key)}
                                        >
                                            {tab.label}
                                            {tab.count ? <span>{tab.count}</span> : null}
                                        </button>
                                    ))}
                                </div>

                                <div className="profile-activity__panel" role="tabpanel" hidden={activityTab !== 'reviews'}>
                                <section className="profile-card profile-reviews-card">
                                    <div className="profile-card__header">
                                        <span className="profile-card__icon"><img src={starIcon} alt="" /></span>
                                        <div>
                                            <h2>Отзывы</h2>
                                            <p>{reviewHistory.length > 0 ? `Последние публикации — ${reviewHistory.length}` : 'Публикаций пока нет'}</p>
                                        </div>
                                    </div>

                                    <div className="profile-reviews-card__list">
                                        {reviewHistory.length > 0 ? reviewHistory.map((reviewItem) => (
                                            <ReviewComponent
                                                key={reviewItem.id || `${reviewItem.animeId}-${reviewItem.date}`}
                                                review={reviewItem}
                                                isReview={true}
                                                animeRef={true}
                                                navigate={navigate}
                                                deletable={isOwnProfile() || localStorage.getItem('mod') === 'true'}
                                            />
                                        )) : (
                                            <div className="profile-empty-state">
                                                <span>★</span>
                                                <p>Здесь появятся отзывы пользователя.</p>
                                            </div>
                                        )}
                                    </div>
                                    {hasMoreReviews ? (
                                        <button className="profile-card__more" onClick={() => fetchReviews(reviewPage + 1)}>
                                            Показать ещё
                                        </button>
                                    ) : null}
                                </section>
                                </div>

                                <div className="profile-activity__panel" role="tabpanel" hidden={activityTab !== 'history'}>
                                {canShowWatchHistory() ? (
                                    <section className="profile-card profile-history-card">
                                        <div className="profile-card__header">
                                            <span className="profile-card__icon"><img src={timeIcon} alt="" /></span>
                                            <div>
                                                <h2>Недавно просмотренное</h2>
                                            </div>
                                        </div>

                                        {isOnline && currentWatchSnippet && !currentWatchSnippet.watched ? (
                                            <button className="now-watching" onClick={() => navigate(`/watch/${currentWatchSnippet.animeId}/${currentWatchSnippet.seriesId}`)}>
                                                <img className="thumb" src={`https://api.whitewhale.help/anime/getThumb/${currentWatchSnippet.privateVideoId}_thumb.png`} alt="" />
                                                <span className="info">
                                                    <span className="pill">Смотрит сейчас</span>
                                                    <span className="title">{currentWatchSnippet.animeName}</span>
                                                    <span className="meta">{currentWatchSnippet.series} серия, {currentWatchSnippet.season} сезон</span>
                                                </span>
                                            </button>
                                        ) : null}

                                        <div className="watch-his-container">
                                            {watchHistory.map((watchSnippet) => (
                                                <WatchCardComponent key={watchSnippet.id} preview={true} watchSnippet={watchSnippet} isInteractive={true} />
                                            ))}
                                        </div>
                                        {hasMore ? <button className="profile-card__more" onClick={() => fetchWatchHistory(watchDataPage + 1)}>Показать ещё</button> : null}
                                    </section>
                                ) : canViewPrivateContent() ? (
                                    <section className="profile-card profile-private-card profile-history-card">
                                        <span className="profile-private-card__icon">◉</span>
                                        <h2>История просмотра</h2>
                                        <p>Войдите в аккаунт, чтобы видеть доступную историю и активность друзей.</p>
                                        <button className="profile-card__more" onClick={() => navigate('/login')}>Войти</button>
                                    </section>
                                ) : (
                                    <section className="profile-card profile-private-card profile-history-card">
                                        <span className="profile-private-card__icon">○</span>
                                        <h2>Приватный аккаунт</h2>
                                        <p>Владелец скрыл статистику и историю просмотра.</p>
                                    </section>
                                )}
                                </div>

                                {canViewPrivateContent() ? (
                                    <div className="profile-activity__panel" role="tabpanel" hidden={activityTab !== 'collections'}>
                                        <ProfileCollectionsPanel userId={account.id} kind={collectionsKind} onKindChange={setCollectionsKind} manga={manga} />
                                    </div>
                                ) : null}

                                <div className="profile-activity__panel" role="tabpanel" hidden={activityTab !== 'comments'}>
                                <section className="profile-card profile-comments-section">
                                    <div className="profile-comments-section__inner">
                                        <div className="profile-card__header">
                                            <span className="profile-card__icon"><img src={commentsIcon} alt="" /></span>
                                            <div>
                                                <h2>Комментарии</h2>
                                                <p>{comments.length > 0 ? `Стена профиля — ${comments.length}` : 'Пока тихо'}</p>
                                            </div>
                                        </div>

                                        <div className="profile-comment-form">
                                            <textarea
                                                value={newComment}
                                                maxLength="200"
                                                onChange={handleNewCommentChange}
                                                placeholder={viewerHasSession ? 'Напишите что-нибудь хорошее…' : 'Войдите, чтобы оставить комментарий'}
                                                aria-label="Новый комментарий"
                                                disabled={!viewerHasSession}
                                            />
                                            <div className="profile-comment-form__footer">
                                                <p>До 200 символов · соблюдайте правила сообщества</p>
                                                <button
                                                    onClick={viewerHasSession ? handleLeaveComment : () => navigate('/login')}
                                                    disabled={viewerHasSession && !newComment.trim()}
                                                >
                                                    {viewerHasSession ? 'Опубликовать' : 'Войти'}
                                                </button>
                                            </div>
                                        </div>

                                        <div className="profile-comments-list">
                                            {comments.length > 0 ? comments.map((comment) => (
                                                <ReviewComponent
                                                    key={comment.id || comment.createdAt || comment.date}
                                                    review={comment}
                                                    isReview={false}
                                                    navigate={navigate}
                                                    deletable={isOwnProfile() || localStorage.getItem('mod') === 'true'}
                                                />
                                            )) : <div className="profile-empty-state"><p>Будьте первым, кто оставит комментарий.</p></div>}
                                        </div>
                                        {hasMoreComments ? <button type="button" className="profile-comments-section__more" onClick={loadMoreComments}>Загрузить ещё</button> : null}
                                    </div>
                                </section>
                                </div>
                            </section>
                    </main>

                        {/* Account warnings and popups */}
                        {isOwnProfile() && account.subscribed && !email.includes('@') && email !== 'dummy' && (
                            <div className="popup-container">
                                <div className="popup">
                                    <h2>Привяжите почту к аккаунту</h2>
                                    <p>Добавьте почту, чтобы сохранить доступ к аккаунту и статистике</p>
                                    <button type="button" className='ui-btn ui-btn--secondary' onClick={() => navigate('/settings')}>
                                        В настройки
                                    </button>
                                </div>
                            </div>
                        )}

                        {account.banned && (
                            <div className="popup-container">
                                <div className="popup">
                                    <h2>Этот профиль недоступен</h2>
                                    <p>Пользователь был заблокирован за нарушение правил сообщества</p>
                                    <button type="button" className='ui-btn ui-btn--secondary' onClick={() => navigate('/')}>
                                        На главную
                                    </button>
                                </div>
                            </div>
                        )}

                </div>
            ) : notFound ? (
                <div className="profile-not-found">
                    <div className="ui-empty">
                        <h1 className="ui-empty__title">Профиль {nickname} не найден</h1>
                        <p className="ui-empty__text">Возможно, ник изменился или аккаунт удалён.</p>
                    </div>
                </div>
            ) : (
                <ProfileSkeleton />
            )}
            <Footer />

            {/* Popups */}
            {showFriendsPopup && canViewPrivateContent() && (
                <FriendsPopup
                    friends={friends}
                    closePopup={toggleFriendsPopup}
                />
            )}

            {showGiftPopup && (
                <AnimixPremiumGiftPopup
                    nickname={account.nickname}
                    onClose={() => setShowGiftPopup(false)}
                />
            )}

            {showFramePopup && (
                <FramePopup
                    availableFrames={frames}
                    allFrames={allFrames}
                    readonly={true}
                    nickname={account.nickname}
                    selectedFrame={selectedFrame}
                    closePopup={() => setShowFramePopup(false)}
                />
            )}
        </div>
    );
};

// A new nickname mounts a fresh page: all per-profile state (lists, pages, comments) resets
// and the skeleton shows while the next profile loads, instead of the old one lingering.
const ProfilePage = () => {
    const { nickname } = useParams();
    return <ProfilePageContent key={nickname || 'self'} />;
};

export default ProfilePage;
